import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, EMPTY, from, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { MealSlotModel } from '@/models';
import { FetchAllMealSlotsPayload } from '@/store/slices/staff/meal-slots.slice';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';

export const fetchAllMealSlots: PayloadEpic<FetchAllMealSlotsPayload, MealSlotModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.mealSlots.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.mealSlots.setIsLoading(true)),
            fetchAssetLots(payload).pipe(
                switchMap(({ data }) => from([
                    actions.mealSlots.setAll(data.results),
                    actions.mealSlots.setTotalCount(data.count),
                ])),
                catchError((error) => {
                    console.error('fetchAllMealSlots', error);

                    return EMPTY;
                }),
            ),
            of(actions.mealSlots.setIsLoading(false)),
        )),
    );
};

const fetchAssetLots = (payload: FetchAllMealSlotsPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<MealSlotModel>>(`${apiEndpoints.mealSlots()}?${searchParams}`);
};
